(function ($) {
	var isReset = false;

	var multiSelectArgs = {
		containerHTML: '<div class="multi-select-container">',
		menuHTML: '<div class="multi-select-menu">',
		buttonHTML:
			'<span class="multi-select-button"><svg xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414"><path class="filtering-arrow" id="Path_2" data-name="Path 2" d="M0,0,4.005,4,8,0" transform="translate(1.414 1.414)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/></svg></span>',
		menuItemsHTML: '<div class="multi-select-menuitems">',
		menuItemHTML: '<label class="multi-select-menuitem">',
		presetsHTML: '<div class="multi-select-presets">',
		modalHTML: undefined,
		activeClass: 'multi-select-container--open',
		noneText: '',
		text: '',
		allText: undefined,
		presets: undefined,
		positionedMenuClass: 'multi-select-container--positioned',
		positionMenuWithin: undefined,
		viewportBottomGutter: 20,
		menuMinHeight: 200,
	};

	if ($('.js-filtered-resources').length > 0) {
		$('.js-filtered-resources').each(function () {
			// @ts-ignore-next
			$(this).find('.js-resources').isotope({
				itemSelector: '.js-resource',
				filter: '*',
			});

			$(this)
				.find('select[name="filter-topics"]')
				// @ts-ignore-next
				.multiSelect(
					$.extend({}, multiSelectArgs, {
						noneText: $(this)
							.find('select[name="filter-topics"]')
							.data('all-topics'),
						text: $(this)
							.find('select[name="filter-topics"]')
							.data('topics'),
					})
				);

			$(this)
				.find('select[name="filter-locations"]')
				// @ts-ignore-next
				.multiSelect(
					$.extend({}, multiSelectArgs, {
						noneText: $(this)
							.find('select[name="filter-locations"]')
							.data('all-locations'),
						text: $(this)
							.find('select[name="filter-locations"]')
							.data('locations'),
					})
				);

			$(this)
				.find('select[name="filter-languages"]')
				// @ts-ignore-next
				.multiSelect(
					$.extend({}, multiSelectArgs, {
						noneText: $(this)
							.find('select[name="filter-languages"]')
							.data('all-languages'),
						text: $(this)
							.find('select[name="filter-languages"]')
							.data('languages'),
					})
				);

			listenFiltersSelect($(this));
		});
	}

	// @ts-ignore-next
	function listenFiltersSelect(module) {
		module.find('.js-resource-filters select').change(function () {
			// @ts-ignore-next
			var value = $(this).val();

			if (!isReset) {
				filterResources(module);
			}

			displayResetFilters(module);
		});
	}

	// @ts-ignore-next
	function displayResetFilters(module) {
		var filtersWrap = module.find('.js-resource-filters'),
			// @ts-ignore-next
			filterValues = [],
			resetFiltersEl = filtersWrap.children('.js-reset-filters'),
			newResetFiltersEl = $(
				'<li class="js-reset-filters"><button class="multi-select-button reset">' +
					filtersWrap.data('reset-filters') +
					'</button></li>'
			);

		$('select', filtersWrap).each(function () {
			// @ts-ignore-next
			$.merge(filterValues, $(this).val() || []);
		});

		if (filterValues.length && !resetFiltersEl.length) {
			filtersWrap.append(newResetFiltersEl);
			newResetFiltersEl.find('button').click(function () {
				resetFilters(module);
			});
		}

		if (!filterValues.length && resetFiltersEl.length) {
			resetFiltersEl.remove();
		}
	}

	// @ts-ignore-next
	function resetFilters(module) {
		isReset = true;

		module
			.find('.js-resource-filters input[type="checkbox"]')
			.each(function () {
				// @ts-ignore-next
				if ($(this).prop('checked')) {
					// @ts-ignore-next
					$(this).click();
				}
			});

		isReset = false;

		filterResources(module);
	}

	// @ts-ignore-next
	function filterResources(module) {
		var filters = {};
		var isotope_filters = '*';

		var filterTopics = module.find('select[name="filter-topics"]').val();
		var filterLocations = module
			.find('select[name="filter-locations"]')
			.val();
		var filterLanguages = module
			.find('select[name="filter-languages"]')
			.val();

		if (filterTopics) {
			// @ts-ignore-next
			filters.topics = filterTopics;
		}

		if (filterLocations) {
			// @ts-ignore-next
			filters.locations = filterLocations;
		}

		if (filterLanguages) {
			// @ts-ignore-next
			filters.languages = filterLanguages;
		}

		if (!$.isEmptyObject(filters)) {
			isotope_filters = getComboFilter(filters);
		}

		module.find('.js-resources').isotope({
			itemSelector: '.js-resource',
			filter: isotope_filters,
		});
	}

	// @ts-ignore-next
	function getComboFilter(filters) {
		var i = 0;
		// @ts-ignore-next
		var comboFilters = [];
		var message = [];

		for (var prop in filters) {
			message.push(filters[prop].join(' '));
			var filterGroup = filters[prop];
			// skip to next filter group if it doesn't have any values
			if (!filterGroup.length) {
				continue;
			}
			if (i === 0) {
				// copy to new array
				comboFilters = filterGroup.slice(0);
			} else {
				var filterSelectors = [];
				// copy to fresh array
				// @ts-ignore-next
				var groupCombo = comboFilters.slice(0); // [ A, B ]
				// merge filter Groups
				for (var k = 0, len3 = filterGroup.length; k < len3; k++) {
					for (var j = 0, len2 = groupCombo.length; j < len2; j++) {
						filterSelectors.push(groupCombo[j] + filterGroup[k]); // [ 1, 2 ]
					}
				}
				// apply filter selectors to combo filters for next group
				comboFilters = filterSelectors;
			}
			i++;
		}

		var comboFilter = comboFilters.join(', ');
		return comboFilter;
	}
})(jQuery);
